"use strict";

function scrollOffset(element) {
  // If fixed element is not header, change value
  var header = document.querySelector('header');
  var headerPosition = window.getComputedStyle(header).getPropertyValue('position') || header.style.position;
  var headerHeight = header.offsetHeight;
  var elementPosition = element.offsetTop;
  var isHeaderFixed = headerPosition === 'fixed';
  return isHeaderFixed ? elementPosition - headerHeight - 10 : elementPosition - 15;
}

;
var applyButton = document.querySelectorAll('[data-apply]');
var jobTitleInput = document.getElementById('job-title');

var _loop = function _loop(i) {
  var position = applyButton[i].getAttribute('data-apply');
  applyButton[i].addEventListener('click', function () {
    jobTitleInput.value = position;
    window.scrollTo({
      left: 0,
      top: scrollOffset(document.getElementById('apply')),
      behavior: 'smooth'
    });
  });
};

for (var i = 0; i < applyButton.length; i += 1) {
  _loop(i);
}